import { DiscussionEmbed } from "disqus-react"

const DisqusComments = ({ blogType, blog }) => {
  const disqusShortname = "cloudpedia-ai"
  const disqusConfig = {
    url: `https://cloudpedia.ai/${blogType}/${blog.content_id}/`,
    identifier: `${blogType}_${blog.content_id}`, // Single post id
    title: blog.title // Single post title
  }
  return (
    <>
      <hr />
      <div>
        <h3>We Value Your Input</h3>
        <p>We are committed to continuous improvement of our code and content based on valuable audience feedback.  Please share your comments, suggestions, and any areas where we can enhance your experience.</p>
      </div>
      <br />
      <div>
        <DiscussionEmbed
          shortname={disqusShortname}
          config={disqusConfig}
        />
      </div>
    </>
  )
}

export default DisqusComments;
